<template>
  <div class="top-ex">
    <Row>
      <Col span="10" class="top">
        <div class="top-l">
          <div class="top-l-l">
            <a
              class="top_logo"
              href="javascript:;"
              @click="$router.push(`/home/index/${exhibitionId}`)"
            >
              <img
                :src="exhibitionInfo.logo"
                v-if="exhibitionInfo && exhibitionInfo.logo"
              />
              <img v-else src="@/assets/img/empty.png" />
            </a>
            <div class="top-msg">
              <h2>
                {{ exhibitionInfo.name }} <span>官方在线</span>
                <img src="@assets/img/vip.png" />
              </h2>
              <p>{{ exhibitionInfo.address }}</p>
              <p>
                {{ exhibitionInfo.startData | moment("YYYY年MM月DD日 - ") }}
                {{ exhibitionInfo.endDate | moment("MM月DD日") }}
              </p>
            </div>
          </div>
        </div>
      </Col>
      <Col span="14">
        <div class="inp-box">
          <div class="inp-wrap">
            <div class="inp">
              <div class="line"></div>
              <iSelect
                v-model="type"
                style="width: 74px"
                @on-change="selectHandle"
              >
                <Option
                  v-for="item in arr"
                  :value="item.value"
                  :key="'search-' + item.value"
                  >{{ item.label }}</Option
                >
              </iSelect>
              <Input
                search
                v-model="search"
                enter-button="搜索"
                style="width: 350px"
                @on-search="searchHandle"
              />
            </div>
            <div class="search-info">
              <div
                class="item"
                v-for="(item, index) in history"
                :key="'se-' + index"
                :class="{ active: item === search }"
                @click="search = item"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <Button
            type="primary"
            ghost
            style="margin-left: 20px; border-radius: 0"
            @click="addNeeds()"
            >免费发布需求</Button
          >
        </div>
      </Col>
    </Row>
    <needsModel ref="needsModel"></needsModel>
  </div>
</template>
<script>
import moment from "moment";
import needsModel from "@components/needsModel";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "top-ex",
  components: {
    needsModel,
  },
  data() {
    return {
      history: [],
      searchType: "show.search.exhibitors",
      search: "",
      type: "1",
      arr: [
        {
          value: "1",
          label: "展商",
        },
        {
          value: "2",
          label: "展品",
        },
        {
          value: "3",
          label: "活动",
        },
        {
          value: "4",
          label: "供需",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      searchTxt: "getSearchTxt",
      Type: "getSearchType",
      exhibitionId: "getExhibitionId",
      userInfo: "getUser",
    }),
    isRegOk() {
      return (
        this.userInfo &&
        this.userInfo.inMember &&
        this.userInfo.inMember.userRole &&
        this.userInfo.inMember.userRole != "VISITOR" &&
        this.userInfo.inMember.userRole != "Visitor"
      );
    },
  },
  watch: {
    $route(to, form) {
      let url = "";
      if (this.type === "1") {
        url = "/home/exhibitor";
      }
      if (this.type === "2") {
        url = "/home/product";
      }
      if (this.type === "3") {
        url = "/home/activity";
      }
      if (this.type === "4") {
        url = "/home/demand";
      }
      if (location.pathname.indexOf(url) === -1) {
        this.setSearchTxt("");
      }
    },
  },
  created() {
    this.init();
    this.search = "";
    this.setSearchTxt("");
    this.type = this.Type || "1";
  },
  methods: {
    ...mapMutations({
      setSearchTxt: "setSearchTxt",
      setSearchType: "setSearchType",
    }),
    ...mapActions({
      addSearch: "search/addSearch",
      getSearch: "search/getSearch",
      unverifiedDialog: "unverifiedDialog",
    }),
    async init() {
      this.getHistroy();
    },
    selectHandle(e) {
      if (e === "1") {
        this.searchType = "show.search.exhibitors";
      }
      if (e === "2") {
        this.searchType = "show.search.products";
      }
      if (e === "3") {
        this.searchType = "show.search.activities";
      }
      if (e === "4") {
        this.searchType = "show.search.supply-demand";
      }
      this.setSearchType(e);
      this.getHistroy();
      this.search = "";
      this.setSearchTxt("");
    },
    async getHistroy() {
      const bool = await this.getSearch({
        exhibitionId: this.exhibitionId,
        origin: this.searchType,
      });
      if (bool && bool.searchWordQuery) {
        this.history = bool.searchWordQuery.tops;
      }
    },
    addNeeds() {
      this.$refs.needsModel.open();
    },
    async searchHandle() {
      this.setSearchTxt(this.search);
      if (!this.search) return;
      // show.search.exhibitors 展商搜索
      // show.search.products 展品搜索
      // show.search.activities 活动搜索
      // show.search.supply-demand 供需搜索
      let url = "";
      let bool = true; // 当前页面也是所选搜索的路由
      if (this.type === "1") {
        url = "/home/exhibitor";
        this.searchType = "show.search.exhibitors";
      }
      if (this.type === "2") {
        url = "/home/product";
        this.searchType = "show.search.products";
      }
      if (this.type === "3") {
        url = "/home/activity";
        this.searchType = "show.search.activities";
      }
      if (this.type === "4") {
        url = "/home/demand";
        this.searchType = "show.search.supply-demand";
      }
      const opt = {
        itemId: this.exhibitionId,
        origin: this.searchType,
        word: this.search,
      };

      await this.addSearch(opt);
      this.getHistroy();
      if (bool) {
        this.$router.push(`${url}/${this.exhibitionId}`);
      }
    },
  },
};
</script>
 
<style scoped lang="scss">
.top-ex {
  max-width: 1200px;
  margin: 0 auto;
  height: 80px;
  margin-top: 33px;
  margin-bottom: 33px;
  ::v-deep {
    .ivu-input-search:before {
      opacity: 0;
    }
  }
  .top {
    &-msg {
      position: relative;
      padding: 0 16px 0 10px;
      border-left: 1px solid #e6e6e6;
      font-size: 12px;
      color: #333;
      h2 {
        font-size: 14px;
        color: #1a1a1a;
        display: flex;
        align-items: center;
        font-style: normal;
        margin-bottom: 6px;
        span {
          color: #0190fe;
          display: inline-block;
          padding-left: 5px;
          padding-right: 5px;
        }
      }
    }
    &-l {
      &-l {
        display: flex;
        align-items: center;
        .top_logo {
          img {
            width: 62px;
            height: 62px;
            margin-right: 10px;
            // object-fit:cover ;
          }
        }
        img {
          vertical-align: middle;
          display: block;
          max-width: 80px;
          max-height: 70px;
        }
      }
    }
    &-r {
    }
  }
  .inp {
    width: 420px;
    display: flex;
    border-left: solid 1px #e0e0e0;
    .line {
      height: 36px;
      // width: 1px;
      // background: #e0e0e0;
      position: relative;
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        position: absolute;
        height: 1;
        content: "";
        display: inline-block;
        width: 358px;
        border-top: solid 1px #e0e0e0;
        z-index: 10;
      }
      &::after {
        position: absolute;
        bottom: 0;
        left: 0;
        position: absolute;
        height: 1;
        content: "";
        display: inline-block;
        width: 358px;
        border-top: solid 1px #e0e0e0;
        z-index: 10;
      }
    }
    ::v-deep {
      .ivu-input,
      .ivu-select-selection {
        // height: 36px;
        border-color: transparent;
        box-shadow: 0 0 0 2px transparent;
      }
    }
  }
}
.inp-box {
  display: flex;
  justify-content: flex-end;
}
.search-info {
  margin: 15px 0 26px;
  font-size: 12px;
  color: #666;
  .item {
    display: inline-block;
    padding-right: 20px;
    cursor: pointer;
    &.active {
      color: #1890ff;
    }
  }
}
.histroy {
  width: 266px;
  height: 154px;
  background-color: #fff;
  border: solid 1px #e0e0e0;
}
</style>
